(function() {
  // Hide image
  const imgEl = document.querySelector('#shopify-section-template--14829434962009__form img');
  if(imgEl) {
    imgEl.style.display = 'none';
  }

  // Success note
  const successNoteEle = document.querySelector('.note--contact-success');
  console.log('successNoteEle', successNoteEle);
  if (successNoteEle) {
    setTimeout(() => {
      successNoteEle.style.display = 'none';
    }, 7000);
  }
})();